export default{button:"w_W",destructive:"w_X",primary:"w_Y",secondary:"w_Z",tertiary:"w_a",isFullWidth:"w_b",small:"w_c",medium:"w_d",large:"w_e",leading:"w_f",trailing:"w_g"};
